module.exports = __webpack_public_path__ + "media/images/Moorea-4f5ba5b052f6735c123e305e4166a11c.svg";